import React from 'react';

const QueryContext = React.createContext({ query: '', category: '' });
export default QueryContext;
